import { Form } from "components/Form/base/Form";
import { FormInput } from "components/Form/next";
import { useApi } from "../../../hooks/useApi";
import Joi from "joi";
import { useState } from "react";
import { SpaceBlockingGroup } from "../types";

interface Props {
    clubSlug: string;
    group?: SpaceBlockingGroup;
    callback?: (newGroup: SpaceBlockingGroup) => void;
}

export const SpaceBlockingGroupForm = ({ group, clubSlug, callback = () => {} }: Props) => {
    const api = useApi();
    const [isLoading, setIsLoading] = useState(false);
    const handleSubmit = (data) => {
        return api({
            url: `space/blocking/group/${group?.id || clubSlug}`,
            method: group ? "PUT" : "POST",
            data: { ...data, outputs: data.outputs?.map((output) => output.id) },
            onBefore: () => setIsLoading(false),
            onSuccess: ({ data }) => callback(data),
        });
    };

    const schema = Joi.object({
        name: Joi.string().required().label("Name"),
        description: Joi.string().allow(null, "").label("Beschreibung"),
        color: Joi.string()
            .regex(/^#[0-9A-F]{6}$/i)
            .message("***Die Farbe enthält keinen gültigen Wert!")
            .label("Farbe"),
    }).unknown();

    return (
        <Form onSubmit={handleSubmit} validationSchema={schema} defaultValues={group}>
            <FormInput name="name" label="Name" />
            <FormInput.WYSIWYG name="description" label="Beschreibung" />
            <FormInput type="color" name="color" label="Farbe" />
            <FormInput.Checkbox
                name="controlled"
                label="Sperrungen aus dieser Gruppe für die Platzsteuerung verwenden"
            />
            <FormInput.Submit isLoading={isLoading}>Speichern</FormInput.Submit>
        </Form>
    );
};
